import {
  faBinoculars,
  faCalendarAlt,
  faEnvelope,
  faNoteSticky,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import type { LogActivityType } from './types';

export interface LogActivityTab {
  activityType: LogActivityType;
  icon: IconDefinition;
  key: LogActivityType;
  label: string;
}

export const LOG_ACTIVITY_TABS: LogActivityTab[] = [
  { activityType: 'note', icon: faNoteSticky, key: 'note', label: 'Note' },
  { activityType: 'call', icon: faPhone, key: 'call', label: 'Call' },
  { activityType: 'message', icon: faEnvelope, key: 'message', label: 'Email' },
  { activityType: 'meeting', icon: faCalendarAlt, key: 'meeting', label: 'Meeting' },
  { activityType: 'showing', icon: faBinoculars, key: 'showing', label: 'Tour' },
];

export interface CallResultOption {
  key: string;
  label: string;
}

export const CALL_RESULTS: CallResultOption[] = [
  { key: 'reached', label: 'Connected' },
  { key: 'could_not_reach', label: 'No Answer' },
  { key: 'left_message', label: 'Left Voicemail' },
  { key: 'bad_phone', label: 'Bad Number' },
];

function about(subjectName?: string) {
  return subjectName ? ` about ${subjectName}` : '';
}

function withName(subjectName?: string) {
  return subjectName ? ` and ${subjectName}` : '';
}

function withRecord(subjectName?: string) {
  return subjectName ? ` with ${subjectName}` : '';
}

// Read by the model as the instruction it is carrying out, so they are phrased as one.
export const purposes: Record<LogActivityType, string> = {
  note: 'write a note',
  call: 'log a phone call',
  message: 'log a past email',
  meeting: 'log a meeting',
  showing: 'log a property tour',
};

export const placeholders = {
  note: (subjectName?: string) => `Log a note${about(subjectName)}...`,
  call: (subjectName?: string) => `What did you${withName(subjectName)} discuss?`,
  email: (subjectName?: string) => `Log an email${withRecord(subjectName)}...`,
  meeting: (subjectName?: string) => `Describe how your meeting${withRecord(subjectName)} went...`,
  tour: (subjectName?: string) => `Describe how your tour${withRecord(subjectName)} went...`,
};
